import React from "react";
import {oneOf} from "prop-types";
import "./index.scss";

function Text(props) {
    const {size, children, color} = props;
    const align = props.align || "left";
    return <p className={`text size${size} align-${align} color-${color || "default"}`}>{children}</p>
}

Text.propTypes = {
    size: oneOf([18, 16, 14, 12, 10]).isRequired,
    align: oneOf(["center", "right", "left"]),
    color: oneOf([null, "danger", "success", "light"])
}

export default Text;